<template>
    <div class="toprated" @click="gotoProfile">
        <div class="container-fluid cont-w border bg-white shadow-sm">
            <div class="row">
                <div class="col-4">
                    <div class="p-2">
                        <img :src="require(`@/assets/KOVATEK/IMAGES/${image}`)" alt="" class="rounded-circle img-height mt-2" />
                    </div>
                </div>
                <div class="col-8">
                    <div class="text-left">
                        <h6 class="kovatek-color font-weight-bold mt-3 text-size">{{name}}<img class="ml-2 mb-1" style="height:16px;" src="../assets/KOVATEK/svg-embed/correct.svg" alt="" /></h6>
                        <p class="font-weight-bold text-size2 mt-1 mb-0">{{specialization}}</p>
                        <p class="text-uppercase text-size2 mt-1 font-weight-bold" v-bind:class= "{'text-senior': (level == 'senior'), 'text-intermediate': (level == 'intermediate')}">{{level}}</p>

                        <h6 class="pt-1 text-size2 font-weight-bold add-experienced-col">
                             <img src="../assets/KOVATEK/svg-embed/best.svg" alt="" />
                            <span class="text-size1 ml-2">{{rating}}</span> <span class="text-size4 ml-2"> {{reviews}} reviews</span> 
                        </h6>
                    </div>
                   
                </div>
            </div>
            <div class="row">
                <div class="col-4 text-size"><span class="font-weight-bolder text-size1 ml-3">${{charge}}</span>/hr</div>
                <div class="col-8 text-left mt-1 text-size2"><font-awesome-icon icon="map-marker-alt" class="text-dark mx-1"></font-awesome-icon>{{location}}</div>
            </div>
            <div class="w-90 m-auto">
                <a-divider class="my-2"/>
            </div>
            <div>
                <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-2 py-1 mx-1 mb-2 rounded text-size2 text-dark"  v-for="skill in skills" :key="skill">
                        {{skill}}</span>
                </div>
                <!-- <div class="text-left">
                    <router-link to="/profile">
                        <button class="btn btn-kovatek px-3 py-2 text-size" style="font-size:10px">View Profile</button>
                    </router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'toprated',
    props: {
        name: {
            type: String,
            required: true
            },
        image: String,
        specialization: String,
        charge:String,
        location: String,
        skills: Array,
        level: String,
        rating:String,
        reviews:String
    },
    data(){
        return{
        }
    },
    methods: {
        gotoProfile(){
            this.$router.push('/profile')
        }
    },
    computed: {
    }
}
</script>

<style scoped>
.cont-w{
    width: 210px;
    height: 190px;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0,0,0, 0.2);

}
.text-size{
    font-size: 12px;
}
.text-size1{
    font-size: 16px;
}
.text-size2{
    font-size: 10px;
}
.text-size4{
    font-size: 8px;
}
.img-height{
    width: 50px;
    height: 50px;
}
.kovatek-color{
    color: #20409a;
}
.add-experienced-col{
    color: #65d461;
}
.w-90{
    width:90%;
}
.bg-skills{
    background-color: #a9ffa6;
    /* C0E4D7; */
}
.btn-kovatek{
  background-color: #20409a;
  border: solid 1px #20409a;
  outline: 0;
  color: #fff;
  transition: .25s;
  border-radius: 5px;
  font-size: 14px;
}
.btn-kovatek:hover{
  background-color: #06216d;
  border: solid 1px #06216d;
  color: #fff;
}
.text-senior{
    color: #BD6377;
}
.text-intermediate{
    color: #BDBD50;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
.cont-w{
    width: 220px;
    height: 210px;
}
}
@media screen and (min-width: 768px) and (max-width: 991px){
  
}
@media screen and (max-width: 767px){
.cont-w{
    width: 220px;
    height: 210px;
}
}

@media screen and (max-width: 540px){

}
</style>